import styled from "styled-components";

const ProfileDetailsContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
`;

export default ProfileDetailsContainer;